import {
    TOGGLE_STEPS_LIST, 
    TOGGLE_RESPONSES_LIST, 
    SELECT_RESPONSE, 
    RESET_CONFIGURATION,
    _MCP,
    PURCHASE_CORRECTION_SUCCESS, PURCHASE_CORRECTION_FAIL, PURCHASE_CORRECTION_SENT,
    PURCHASE_SENT, PURCHASE_SUCCESS, PURCHASE_FAIL,
    PREAUTH_COMPLETION_SUCCESS, PREAUTH_COMPLETION_SENT, PREAUTH_COMPLETION_FAIL,
    PREAUTH_SUCCESS, PREAUTH_FAIL, PREAUTH_SENT,
    REFUND_SUCCESS, REFUND_FAIL, REFUND_SENT,
    INDEPENDENT_REFUND_SUCCESS, INDEPENDENT_REFUND_FAIL, INDEPENDENT_REFUND_SENT,
    PURCHASE_WITH_VAULT_SUCCESS, PURCHASE_WITH_VAULT_SENT, PURCHASE_WITH_VAULT_FAIL,
    PREAUTH_WITH_VAULT_SUCCESS, PREAUTH_WITH_VAULT_SENT, PREAUTH_WITH_VAULT_FAIL,
    INDREFUND_WITH_VAULT_SUCCESS, INDREFUND_WITH_VAULT_SENT, INDREFUND_WITH_VAULT_FAIL,
    GETRATE_SENT, GETRATE_SUCCESS, GETRATE_FAIL,
    UPDATE_PREV_SUCC_STEP, UPDATE_TXN_NUMBER, UPDATE_MCP_RATE_TOKEN,
    PURCHASE_3DS_SENT, PURCHASE_3DS_SUCCESS, PURCHASE_3DS_FAIL,
    PURCHASE_3DS_VAULT_SENT, PURCHASE_3DS_VAULT_SUCCESS, PURCHASE_3DS_VAULT_FAIL,
    PREAUTH_3DS_SENT, PREAUTH_3DS_SUCCESS, PREAUTH_3DS_FAIL,
    PREAUTH_3DS_VAULT_SENT, PREAUTH_3DS_VAULT_SUCCESS, PREAUTH_3DS_VAULT_FAIL

} from './types'

const HOST = "https://developer.moneris.com/demoapi"
//http://monerisdeveloperauth.monad.moneris.com:8081
//https://localhost:5001
//https://developer.moneris.com:8081

export const toggleStepsList = () => dispatch => {
    dispatch({ feature: _MCP, type: TOGGLE_STEPS_LIST });
}

export const toggleResponsesList = () => dispatch => {
    dispatch({ feature: _MCP, type: TOGGLE_RESPONSES_LIST });
}

export const selectResponse = (responseId) => dispatch => {
    dispatch({ feature: _MCP, type: SELECT_RESPONSE, payload: responseId });
}

export const updatePrevSuccStep = (stepId) => dispatch => {
    dispatch({ feature: _MCP, type: UPDATE_PREV_SUCC_STEP, payload: stepId });
}

export const resetConfiguration = () => dispatch => {
    dispatch({ feature: _MCP, type: RESET_CONFIGURATION });
}

export const makeGetRate = (getRateRequest) => async dispatch => {
    dispatch({ feature: _MCP, type: GETRATE_SENT });

    const { storeId, apiToken } = getRateRequest;
    try {
        let response = await fetch(`${HOST}/api/mcp/getrate`, {
            method: 'POST',
            headers: {
                'accept': '*/*',
                'content-type': 'application/json' 
            },
            body: JSON.stringify({
                store_id: storeId,
                api_token: apiToken,
            }),
        })

        let responseJson = await response.json();
        var output = "";
        var mcpRateToken = "null";

        if(responseJson.output)
            output = responseJson.output;

        if(responseJson.MCPRateToken)
            mcpRateToken = responseJson.MCPRateToken;

        if(mcpRateToken === "null") {
            dispatch({ feature: _MCP, type: GETRATE_FAIL, payload: output});
            return;
        }

        if(responseJson.TxnNumber)
            dispatch({ feature: _MCP, type: UPDATE_TXN_NUMBER, payload: responseJson.TxnNumber });
        
        dispatch({ feature: _MCP, type: UPDATE_MCP_RATE_TOKEN, payload: mcpRateToken });
        dispatch({ feature: _MCP, type: GETRATE_SUCCESS, payload: output });
        dispatch({ feature: _MCP, type: UPDATE_PREV_SUCC_STEP, payload: 3 });
    } catch (error) {
        console.log("//////////////////////////" + error);
        dispatch({ feature: _MCP, type: GETRATE_FAIL, payload: 'Error, please try again.'});
    }
}

export const makePurchase = (purchaseRequest) => async dispatch => {
    dispatch({ feature: _MCP, type: PURCHASE_SENT });

    const { storeId, apiToken, orderId, pan, expdate, amount, currency, mcpRateToken } = purchaseRequest;
    try {
        let response = await fetch(`${HOST}/api/mcp/purchase`, {
            method: 'POST',
            headers: {
                'accept': '*/*',
                'content-type': 'application/json' 
            },
            body: JSON.stringify({
                store_id: storeId,
                api_token: apiToken,
                order_id: orderId,
                pan: pan,
                expdate: expdate,
                amount: amount,
                currency: currency,
                mcp_rate_token: mcpRateToken
            }),
        })

        let responseJson = await response.json();
        var output = "Error, please try again.";
        var responseCode = 50;

        if(responseJson.responseCode)
            responseCode = parseInt(responseJson.responseCode);

        if(responseJson.output)
            output = responseJson.output;

        if(responseCode >= 50) {
            dispatch({ feature: _MCP, type: PURCHASE_FAIL, payload: output });
            return;
        }

        if(responseJson.TxnNumber)
            dispatch({ feature: _MCP, type: UPDATE_TXN_NUMBER, payload: responseJson.TxnNumber });

        dispatch({ feature: _MCP, type: PURCHASE_SUCCESS, payload: output });
        dispatch({ feature: _MCP, type: UPDATE_PREV_SUCC_STEP, payload: 4 });
    } catch (error) {
        console.log("//////////////////////////" + error);
        dispatch({ feature: _MCP, type: PURCHASE_FAIL, payload: 'Error, please try again.'});
    }
}

export const makePurchase3DS = (purchase3DSRequest) => async dispatch => {
    dispatch({ feature: _MCP, type: PURCHASE_3DS_SENT });

    const { storeId, apiToken, orderId, pan, expdate, amount, currency, mcpRateToken, cavv } = purchase3DSRequest;

    try {
        let response = await fetch(`${HOST}/api/mcp/cavvpurchase`, {
            method: 'POST',
            headers: {
                'accept': '*/*',
                'content-type': 'application/json' 
            },
            body: JSON.stringify({
                store_id: storeId,
                api_token: apiToken,
                order_id: orderId,
                pan: pan,
                expdate: expdate,
                amount: amount,
                currency: currency,
                mcp_rate_token: mcpRateToken,
                cavv: cavv
            }),
        })

        let responseJson = await response.json();
        var output = "Error, please try again.";
        var responseCode = 50;

        if(responseJson.responseCode)
            responseCode = parseInt(responseJson.responseCode);

        if(responseJson.output)
            output = responseJson.output;

        if(responseCode >= 50) {
            dispatch({ feature: _MCP, type: PURCHASE_3DS_FAIL, payload: output });
            return;
        }

        if(responseJson.TxnNumber)
            dispatch({ feature: _MCP, type: UPDATE_TXN_NUMBER, payload: responseJson.TxnNumber });

        dispatch({ feature: _MCP, type: PURCHASE_3DS_SUCCESS, payload: output });
        dispatch({ feature: _MCP, type: UPDATE_PREV_SUCC_STEP, payload: 5 });
    } catch (error) {
        console.log("//////////////////////////" + error);
        dispatch({ feature: _MCP, type: PURCHASE_3DS_FAIL, payload: 'Error, please try again.'});
    }
}

export const makePurchase3DSVault = (purchase3DSVaultRequest) => async dispatch => {
    dispatch({ feature: _MCP, type: PURCHASE_3DS_VAULT_SENT });

    const { storeId, apiToken, orderId, expdate, amount, currency, mcpRateToken, cavv } = purchase3DSVaultRequest;

    try {
        let response = await fetch(`${HOST}/api/mcp/rescavvpurchase`, {
            method: 'POST',
            headers: {
                'accept': '*/*',
                'content-type': 'application/json' 
            },
            body: JSON.stringify({
                store_id: storeId,
                api_token: apiToken,
                order_id: orderId,
                cavv: cavv,
                expdate: expdate,
                amount: amount,
                currency: currency,
                mcp_rate_token: mcpRateToken
            }),
        })

        let responseJson = await response.json();
        var output = "Error, please try again.";
        var responseCode = 50;

        if(responseJson.responseCode)
            responseCode = parseInt(responseJson.responseCode);

        if(responseJson.output)
            output = responseJson.output;

        if(responseCode >= 50) {
            dispatch({ feature: _MCP, type: PURCHASE_3DS_VAULT_FAIL, payload: output });
            return;
        }

        if(responseJson.TxnNumber)
            dispatch({ feature: _MCP, type: UPDATE_TXN_NUMBER, payload: responseJson.TxnNumber });

        dispatch({ feature: _MCP, type: PURCHASE_3DS_VAULT_SUCCESS, payload: output });
        dispatch({ feature: _MCP, type: UPDATE_PREV_SUCC_STEP, payload: 6 });
    } catch (error) {
        console.log("//////////////////////////" + error);
        dispatch({ feature: _MCP, type: PURCHASE_3DS_VAULT_FAIL, payload: 'Error, please try again.'});
    }
}

export const makePreauth = (preAuthRequest) => async dispatch => {
    dispatch({ feature: _MCP, type: PREAUTH_SENT });


    const { storeId, apiToken, orderId, pan, expdate, amount, currency, mcpRateToken } = preAuthRequest;
    try {
        let response = await fetch(`${HOST}/api/mcp/preauth`, {
            method: 'POST',
            headers: {
                'accept': '*/*',
                'content-type': 'application/json' 
            },
            body: JSON.stringify({
                store_id: storeId,
                api_token: apiToken,
                order_id: orderId,
                pan: pan,
                expdate: expdate,
                amount: amount,
                currency: currency,
                mcp_rate_token: mcpRateToken
            }),
        })

        let responseJson = await response.json();
        var output = "Error, please try again.";
        var responseCode = 50;

        if(responseJson.responseCode)
            responseCode = parseInt(responseJson.responseCode);

        if(responseJson.output)
            output = responseJson.output;

        if(responseCode >= 50) {
            dispatch({ feature: _MCP, type: PREAUTH_FAIL, payload: output });
            return;
        }
        if(responseJson.TxnNumber)
            dispatch({ feature: _MCP, type: UPDATE_TXN_NUMBER, payload: responseJson.TxnNumber });
        
        dispatch({ feature: _MCP, type: PREAUTH_SUCCESS, payload: output });
        dispatch({ feature: _MCP, type: UPDATE_PREV_SUCC_STEP, payload: 7 });
    } catch (error) {
        console.log("//////////////////////////" + error);
        dispatch({ feature: _MCP, type: PREAUTH_FAIL, payload: 'Error, please try again.'});
    }
}

export const makePreAuth3DS = (preAuth3DSRequest) => async dispatch => {
    dispatch({ feature: _MCP, type: PREAUTH_3DS_SENT });

    const { storeId, apiToken, orderId, pan, expdate, amount, currency, mcpRateToken, cavv } = preAuth3DSRequest;

    try {
        let response = await fetch(`${HOST}/api/mcp/cavvpreauth`, {
            method: 'POST',
            headers: {
                'accept': '*/*',
                'content-type': 'application/json' 
            },
            body: JSON.stringify({
                store_id: storeId,
                api_token: apiToken,
                order_id: orderId,
                pan: pan,
                cavv: cavv,
                expdate: expdate,
                amount: amount,
                currency: currency,
                mcp_rate_token: mcpRateToken
            }),
        })

        let responseJson = await response.json();
        var output = "Error, please try again.";
        var responseCode = 50;

        if(responseJson.responseCode)
            responseCode = parseInt(responseJson.responseCode);

        if(responseJson.output)
            output = responseJson.output;

        if(responseCode >= 50) {
            dispatch({ feature: _MCP, type: PREAUTH_3DS_FAIL, payload: output });
            return;
        }
        if(responseJson.TxnNumber)
            dispatch({ feature: _MCP, type: UPDATE_TXN_NUMBER, payload: responseJson.TxnNumber });

        dispatch({ feature: _MCP, type: PREAUTH_3DS_SUCCESS, payload: output });
        dispatch({ feature: _MCP, type: UPDATE_PREV_SUCC_STEP, payload: 8 });
    } catch (error) {
        console.log("//////////////////////////" + error);
        dispatch({ feature: _MCP, type: PREAUTH_3DS_FAIL, payload: 'Error, please try again.'});
    }
}

export const makePreAuth3DSVault = (preAuth3DSVaultRequest) => async dispatch => {
    dispatch({ feature: _MCP, type: PREAUTH_3DS_VAULT_SENT });

    const { storeId, apiToken, orderId, cavv, expdate, amount, currency, mcpRateToken } = preAuth3DSVaultRequest;

    try {
        let response = await fetch(`${HOST}/api/mcp/rescavvpreauth`, {
            method: 'POST',
            headers: {
                'accept': '*/*',
                'content-type': 'application/json' 
            },
            body: JSON.stringify({
                store_id: storeId,
                api_token: apiToken,
                order_id: orderId,
                cavv: cavv,
                expdate: expdate,
                amount: amount,
                currency: currency,
                mcp_rate_token: mcpRateToken
            }),
        })

        let responseJson = await response.json();
        var output = "Error, please try again.";
        var responseCode = 50;

        if(responseJson.responseCode)
            responseCode = parseInt(responseJson.responseCode);

        if(responseJson.output)
            output = responseJson.output;

        if(responseCode >= 50) {
            dispatch({ feature: _MCP, type: PREAUTH_3DS_VAULT_FAIL, payload: output });
            return;
        }
        if(responseJson.TxnNumber)
            dispatch({ feature: _MCP, type: UPDATE_TXN_NUMBER, payload: responseJson.TxnNumber });

        dispatch({ feature: _MCP, type: PREAUTH_3DS_VAULT_SUCCESS, payload: output });
        dispatch({ feature: _MCP, type: UPDATE_PREV_SUCC_STEP, payload: 9 });
    } catch (error) {
        console.log("//////////////////////////" + error);
        dispatch({ feature: _MCP, type: PREAUTH_3DS_VAULT_FAIL, payload: 'Error, please try again.'});
    }
}

export const makePreauthCompletion = (preAuthCompRequest) => async dispatch => {
    dispatch({ feature: _MCP, type: PREAUTH_COMPLETION_SENT });


    const { storeId, apiToken, orderId, amount, txnNumber, currency, mcpRateToken } = preAuthCompRequest;
    try {
        let response = await fetch(`${HOST}/api/mcp/preauthcompletion`, {
            method: 'POST',
            headers: {
                'accept': '*/*',
                'content-type': 'application/json' 
            },
            body: JSON.stringify({
                store_id: storeId,
                api_token: apiToken,
                order_id: orderId,
                amount: amount,
                txn_number: txnNumber,
                currency: currency,
                mcp_rate_token: mcpRateToken
            }),
        })

        let responseJson = await response.json();
        var output = "Error, please try again.";
        var responseCode = 50;

        if(responseJson.responseCode)
            responseCode = parseInt(responseJson.responseCode);

        if(responseJson.output)
            output = responseJson.output;

        if(responseCode >= 50) {
            dispatch({ feature: _MCP, type: PREAUTH_COMPLETION_FAIL, payload: output });
            return;
        }
        if(responseJson.TxnNumber)
            dispatch({ feature: _MCP, type: UPDATE_TXN_NUMBER, payload: responseJson.TxnNumber });
            
        dispatch({ feature: _MCP, type: PREAUTH_COMPLETION_SUCCESS, payload: output });
        dispatch({ feature: _MCP, type: UPDATE_PREV_SUCC_STEP, payload: 10 });
    } catch (error) {
        console.log("//////////////////////////" + error);
        dispatch({ feature: _MCP, type: PREAUTH_COMPLETION_FAIL, payload: 'Error, please try again.'});
    }
}

export const makePurchaseCorrection = (purchaseCorrectionRequest) => async dispatch => {
    dispatch({ feature: _MCP, type: PURCHASE_CORRECTION_SENT });

    const { storeId, apiToken, orderId, txnNumber } = purchaseCorrectionRequest;
    try {
        let response = await fetch(`${HOST}/api/mcp/purchasecorrection`, {
            method: 'POST',
            headers: {
                'accept': '*/*',
                'content-type': 'application/json' 
            },
            body: JSON.stringify({
                store_id: storeId,
                api_token: apiToken,
                order_id: orderId,
                txn_number: txnNumber
            }),
        })

        let responseJson = await response.json();
        var output = "Error, please try again.";
        var responseCode = 50;

        if(responseJson.responseCode)
            responseCode = parseInt(responseJson.responseCode);

        if(responseJson.output)
            output = responseJson.output;

        if(responseCode >= 50) {
            dispatch({ feature: _MCP, type: PURCHASE_CORRECTION_FAIL, payload: output });
            return;
        }
        if(responseJson.TxnNumber)
            dispatch({ feature: _MCP, type: UPDATE_TXN_NUMBER, payload: responseJson.TxnNumber });

        dispatch({ feature: _MCP, type: PURCHASE_CORRECTION_SUCCESS, payload: output });
        dispatch({ feature: _MCP, type: UPDATE_PREV_SUCC_STEP, payload: 11 });
    } catch (error) {
        console.log("//////////////////////////" + error);
        dispatch({ feature: _MCP, type: PURCHASE_CORRECTION_FAIL, payload: 'Error, please try again.'});
    }
}

export const makeRefund = (refundRequest) => async dispatch => {
    dispatch({ feature: _MCP, type: REFUND_SENT });


    const { storeId, apiToken, orderId, amount, txnNumber, currency, mcpRateToken } = refundRequest;
    try {
        let response = await fetch(`${HOST}/api/mcp/refund`, {
            method: 'POST',
            headers: {
                'accept': '*/*',
                'content-type': 'application/json' 
            },
            body: JSON.stringify({
                store_id: storeId,
                api_token: apiToken,
                order_id: orderId,
                amount: amount,
                txn_number: txnNumber,
                currency: currency,
                mcp_rate_token: mcpRateToken
            }),
        })

        let responseJson = await response.json();
        var output = "Error, please try again.";
        var responseCode = 50;

        if(responseJson.responseCode)
            responseCode = parseInt(responseJson.responseCode);

        if(responseJson.output)
            output = responseJson.output;

        if(responseCode >= 50) {
            dispatch({ feature: _MCP, type: REFUND_FAIL, payload: output });
            return;
        }

        if(responseJson.TxnNumber)
            dispatch({ feature: _MCP, type: UPDATE_TXN_NUMBER, payload: responseJson.TxnNumber });
    

        dispatch({ feature: _MCP, type: REFUND_SUCCESS, payload: output });
        dispatch({ feature: _MCP, type: UPDATE_PREV_SUCC_STEP, payload: 12 });
    } catch (error) {
        console.log("//////////////////////////" + error);
        dispatch({ feature: _MCP, type: REFUND_FAIL, payload: 'Error, please try again.'});
    }
}

export const makeIndependentRefund = (indRefundRequest) => async dispatch => {
    dispatch({ feature: _MCP, type: INDEPENDENT_REFUND_SENT });


    const { storeId, apiToken, orderId, pan, expdate, amount, currency, mcpRateToken } = indRefundRequest;
    try {
        let response = await fetch(`${HOST}/api/mcp/independentrefund`, {
            method: 'POST',
            headers: {
                'accept': '*/*',
                'content-type': 'application/json' 
            },
            body: JSON.stringify({
                store_id: storeId,
                api_token: apiToken,
                order_id: orderId,
                pan: pan,
                expdate: expdate,
                amount: amount,
                currency: currency,
                mcp_rate_token: mcpRateToken
            }),
        })

        let responseJson = await response.json();
        var output = "Error, please try again.";
        var responseCode = 50;

        if(responseJson.responseCode)
            responseCode = parseInt(responseJson.responseCode);

        if(responseJson.output)
            output = responseJson.output;

        if(responseCode >= 50) {
            dispatch({ feature: _MCP, type: INDEPENDENT_REFUND_FAIL, payload: output });
            return;
        }


        if(responseJson.TxnNumber)
            dispatch({ feature: _MCP, type: UPDATE_TXN_NUMBER, payload: responseJson.TxnNumber });

        dispatch({ feature: _MCP, type: INDEPENDENT_REFUND_SUCCESS, payload: output });
        dispatch({ feature: _MCP, type: UPDATE_PREV_SUCC_STEP, payload: 13 });
    } catch (error) {
        console.log("//////////////////////////" + error);
        dispatch({ feature: _MCP, type: INDEPENDENT_REFUND_FAIL, payload: 'Error, please try again.'});
    }
}

export const makePurchaseWithVault = (purchaseWithVaultRequest) => async dispatch => {
    dispatch({ feature: _MCP, type: PURCHASE_WITH_VAULT_SENT });


    const { storeId, apiToken, orderId, expdate, amount, currency, mcpRateToken } = purchaseWithVaultRequest;
    try {
        let response = await fetch(`${HOST}/api/mcp/purchasewithvault`, {
            method: 'POST',
            headers: {
                'accept': '*/*',
                'content-type': 'application/json' 
            },
            body: JSON.stringify({
                store_id: storeId,
                api_token: apiToken,
                order_id: orderId,
                expdate: expdate,
                amount: amount,
                currency: currency,
                mcp_rate_token: mcpRateToken
            }),
        })

        let responseJson = await response.json();
        var output = "Error, please try again.";
        var responseCode = 50;
        var mcpErrorCode = 0;

        if(responseJson.responseCode)
            responseCode = parseInt(responseJson.responseCode);

        if(responseJson.output)
            output = responseJson.output;

        if(responseJson.MCPErrorStatusCode)
            mcpErrorCode = parseInt(responseJson.MCPErrorStatusCode);

        console.log(mcpErrorCode);

        if(mcpErrorCode === 1015) {
            dispatch({ feature: _MCP, type: PURCHASE_WITH_VAULT_FAIL, payload: "Invalid MCP Rate Token. You need a new one.", mcpErrorCode });
            return;
        }

        if(responseCode >= 50) {
            dispatch({ feature: _MCP, type: PURCHASE_WITH_VAULT_FAIL, payload: output });
            return;
        }

        if(responseJson.TxnNumber)
            dispatch({ feature: _MCP, type: UPDATE_TXN_NUMBER, payload: responseJson.TxnNumber });

        dispatch({ feature: _MCP, type: PURCHASE_WITH_VAULT_SUCCESS, payload: output });
        dispatch({ feature: _MCP, type: UPDATE_PREV_SUCC_STEP, payload: 14 });

    } catch (error) {
        console.log("//////////////////////////" + error);
        dispatch({ feature: _MCP, type: PURCHASE_WITH_VAULT_FAIL, payload: 'Error, please try again.'});
    }
}

export const makePreAuthWithVault = (preAuthWithVaultRequest) => async dispatch => {
    dispatch({ feature: _MCP, type: PREAUTH_WITH_VAULT_SENT });


    const { storeId, apiToken, orderId, expdate, amount, currency, mcpRateToken } = preAuthWithVaultRequest;
    try {
        let response = await fetch(`${HOST}/api/mcp/preauthwithvault`, {
            method: 'POST',
            headers: {
                'accept': '*/*',
                'content-type': 'application/json' 
            },
            body: JSON.stringify({
                store_id: storeId,
                api_token: apiToken,
                order_id: orderId,
                expdate: expdate,
                amount: amount,
                currency: currency,
                mcp_rate_token: mcpRateToken
            }),
        })

        let responseJson = await response.json();
        var output = "Error, please try again.";
        var responseCode = 50;

        if(responseJson.responseCode)
            responseCode = parseInt(responseJson.responseCode);

        if(responseJson.output)
            output = responseJson.output;

        if(responseCode >= 50) {
            dispatch({ feature: _MCP, type: PREAUTH_WITH_VAULT_FAIL, payload: output });
            return;
        }

        if(responseJson.TxnNumber)
            dispatch({ feature: _MCP, type: UPDATE_TXN_NUMBER, payload: responseJson.TxnNumber });

        dispatch({ feature: _MCP, type: PREAUTH_WITH_VAULT_SUCCESS, payload: output });
        dispatch({ feature: _MCP, type: UPDATE_PREV_SUCC_STEP, payload: 15 });
    } catch (error) {
        console.log("//////////////////////////" + error);
        dispatch({ feature: _MCP, type: PREAUTH_WITH_VAULT_FAIL, payload: 'Error, please try again.'});
    }
}

export const makeIndRefundWithVault = (indRefundWithVaultRequest) => async dispatch => {
    dispatch({ feature: _MCP, type: INDREFUND_WITH_VAULT_SENT });


    const { storeId, apiToken, orderId, expdate, amount, currency, mcpRateToken } = indRefundWithVaultRequest;
    try {
        let response = await fetch(`${HOST}/api/mcp/independentrefundwithvault`, {
            method: 'POST',
            headers: {
                'accept': '*/*',
                'content-type': 'application/json' 
            },
            body: JSON.stringify({
                store_id: storeId,
                api_token: apiToken,
                order_id: orderId,
                expdate: expdate,
                amount: amount,
                currency: currency,
                mcp_rate_token: mcpRateToken
            }),
        })

        let responseJson = await response.json();
        var output = "Error, please try again.";
        var responseCode = 50;

        if(responseJson.responseCode)
            responseCode = parseInt(responseJson.responseCode);

        if(responseJson.output)
            output = responseJson.output;

        if(responseCode >= 50) {
            dispatch({ feature: _MCP, type: INDREFUND_WITH_VAULT_FAIL, payload: output });
            return;
        }

        if(responseJson.TxnNumber)
            dispatch({ feature: _MCP, type: UPDATE_TXN_NUMBER, payload: responseJson.TxnNumber });

        dispatch({ feature: _MCP, type: INDREFUND_WITH_VAULT_SUCCESS, payload: output });
        dispatch({ feature: _MCP, type: UPDATE_PREV_SUCC_STEP, payload: 16 });
    } catch (error) {
        console.log("//////////////////////////" + error);
        dispatch({ feature: _MCP, type: INDREFUND_WITH_VAULT_FAIL, payload: 'Error, please try again.'});
    }
}
